import React, { useEffect, useState } from "react";
import API from "../../services";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { S3_IMG, shouldShowWagerNotice } from "../../constants/common";
import "./CasinoIframe.scss";
import { RootState } from "../../models/RootState";
import { connect } from "react-redux";
import { setCasinoData } from "../../store/authReducer";
import { FavoriteBorderOutlined, FavoriteOutlined, IosShare } from "@mui/icons-material";
// import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { Dialog } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { toast } from "react-toastify";
import filter from '../../assets/images/filter.svg';
import search from '../../assets/images/search.svg';
import Delete from '../../assets/images/delete.svg'; 
import boxes from '../../assets/images/view-all-svgrepo-com 1.svg';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useRef, useCallback } from "react";
import JumpToTop from '../../assets/images/jump-to-top.svg'
import list from '../../assets/images/nine-small-boxes-svgrepo-com.svg'
import grid from '../../assets/images/list-svgrepo-com.svg'
import { Loader } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding";
import { useTranslation } from "../../hooks/useTranslation";
import { FaCopy, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import { IoLogoFacebook, IoLogoTwitter } from "react-icons/io";

import { getTextColorFromCSSVar } from "../../store/authActions";
import { getDynamicTextColors } from "../../store/authActions";
import WagerNoticeDialog from "../WagerNoticeDialog/WagerNoticeDialog";
interface CasinoPageProps {
  casinoData: any;
  setCasinoData: (data: any) => void;
  activeWallet: any;
  clearCasinoFilters: () => void;
  userDetails: any;
  dynamicTextColors?: any;
}

const CasinoIframe: React.FC<CasinoPageProps> = ({
  casinoData,
  setCasinoData,
  activeWallet,
  clearCasinoFilters,
  userDetails,
  dynamicTextColors
}) => {
  const { t } = useTranslation();
  const location = useLocation();

  // Get dynamic text color classes from Redux instead of calling function
  const pageTextColorClass = dynamicTextColors?.pageTextColorClass || '';
  const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';
  const buttonTextColorClass = dynamicTextColors?.buttonTextColorClass || '';
  const [loading, setLoading] = useState<boolean>(false);
  const [gameSrc, setGameSrc] = useState<string | null>(null);
  const [gameData, setGameData] = useState<any>();
  const [providersList, setProvidersList] = useState<any>();
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [showWagerNotice, setShowWagerNotice] = useState(false);
  const [pendingWagerGameLink, setPendingWagerGameLink] = useState("");
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [shareModalUrl, setShareModalUrl] = useState<string>("");
  const [shareModalText, setShareModalText] = useState<string>("");
  const [pendingGameLink, setPendingGameLink] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [categories, setCategories] = useState<{ key: string; label: string; icon: string }[]>([]);
  const [showProviderModal, setShowProviderModal] = useState(false);
  const [selectedProviders, setSelectedProviders] = useState<string[]>([]);
  const [providerSearch, setProviderSearch] = useState("");
  const [tempSelectedProviders, setTempSelectedProviders] = useState<string[]>([]);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [providerGamesList, setProviderGamesList] = useState<any[]>([]);
  const [categoryGamesList, setCategoryGamesList] = useState<any[]>([]);
  const [filteredProviderItems, setFilteredProviderItems] = useState<any[]>([]);
  const [allProviders, setAllProviders] = useState<any[]>([]);
  const [gamesLoading, setGamesLoading] = useState(false);
  const [allGamesPage, setAllGamesPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);
  const loaderRef = useRef<HTMLDivElement | null>(null);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  const [firstLoadComplete, setFirstLoadComplete] = useState(false);
  const [providerPayload, setProviderPayload] = useState<any | null>(null);
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [lastSearchedText, setLastSearchedText] = useState("");
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isListView, setIsListView] = useState(false);
  const [noSearchResults, setNoSearchResults] = useState(false);


  const dataSeparation = (data: any) => {
    const providersSection = data.find(
      (section: any) =>
        section?.sectionTitle?.toLocaleLowerCase() === "providers"
    );

    const filteredSections = data.filter(
      (section: any) =>
        section?.sectionTitle?.toLocaleLowerCase() !== "providers"
    );

    setGameData(filteredSections);
    setProvidersList(providersSection);
  };

  const handleProvClick = (prov: any) => {
    navigate("/providergames", { state: { prov } });
  };

  useEffect(() => {
    if (casinoData && casinoData.length > 0) {
      dataSeparation(casinoData);
    } else {
      // getCasinoInfo();
    }
    getCategories();
    fetchProviders();
    sessionStorage.setItem("previousPath", location.pathname);
  }, []);

  const handleFavoriteClick = async (game: any) => {
    setCategoryGamesList((prev: any[]) =>
      prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
    );
    setSearchResults((prev: any[]) =>
      prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
    );

    let response;
    try {
      response = await API.post("/webapp/set-favorite", {
        category: game.category,
        id: game.id,
        isFavorite: !game.isFavorite,
        name: game?.name,
        provider: game?.provider,
        subProvider: game?.subProvider,
        thumbnail: game?.thumbnail,
        type: game?.type,
        tgProviderId: game?.tgProviderId,
        tableId: game?.tableId,
        userKey: sessionStorage.getItem("userKey"),
      });
    } catch (error) {
      console.error("Error updating favorite status:", error);
      // Revert on error
      setCategoryGamesList((prev: any[]) =>
        prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
      );
      setSearchResults((prev: any[]) =>
        prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
      );
      return;
    }

    if (response?.data?.status !== "RS_OK") {
      // Revert on non-OK
      setCategoryGamesList((prev: any[]) =>
        prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
      );
      setSearchResults((prev: any[]) =>
        prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
      );
    }
  };



  const resolveCasinoShareLink = async (
    game: any
  ): Promise<{ sharelinkkey: string; webUrl: string }> => {
    const redirectPayload = {
      page: "playgame",
      id: game?.id,
      tgProviderId: game?.tgProviderId,
      provider: game?.provider,
      subProvider: game?.subProvider,
      type: game?.type,
      category: game?.category,
      tableId: game?.tableId ?? "",
      fantastyMetaData: game?.fantastyMetaData,
    };
    const encoded = btoa(JSON.stringify(redirectPayload));

    let response: any;

    if (!response || response?.data?.status !== "RS_OK") {
      response = await API.post("/bo/generate-share-link", { encoded: encoded, page: "casino" });
    }

    if (response?.data?.status !== "RS_OK") {
      const msg = response?.data?.errorDescription;
      throw new Error(typeof msg === "string" && msg.trim() ? msg : "RS_ERR");
    }

    const path = String(response?.data?.url ?? "").trim();
    if (!path.startsWith("/")) throw new Error("Invalid share URL");

    const webUrl = `${window.location.origin}${path}`;
    const u = new URL(webUrl);
    const sharelinkkey = u.searchParams.get("startapp")?.trim();
    if (!sharelinkkey) throw new Error("Invalid share URL");
    return { sharelinkkey, webUrl };
  };

  const buildTelegramShareLink = (sharelinkkey: string): string => {
    const rawTelegramLink = String(userDetails?.telegramLink ?? "").trim();
    if (!rawTelegramLink) throw new Error("Missing telegramLink");
    const normalized = /^https?:\/\//i.test(rawTelegramLink) ? rawTelegramLink : `https://${rawTelegramLink}`;

    let u: URL;
    try {
      u = new URL(normalized);
    } catch {
      throw new Error("Invalid telegramLink");
    }

    const trimmedPath = u.pathname.replace(/\/+$/, "");
    u.pathname = trimmedPath.endsWith("/home") ? trimmedPath : `${trimmedPath}/home`;
    u.searchParams.set("startapp", sharelinkkey);
    return u.toString();
  };

  const tOr = (key: string, fallback: string) => {
    const val = t(key as any) as any;
    return val && typeof val === "string" && val !== key ? val : fallback;
  };

  const openTelegramShare = (urlToShare: string) => {
    const tg = (window as any)?.Telegram?.WebApp;
    try {
      if (tg?.openTelegramLink) return tg.openTelegramLink(urlToShare);
      if (tg?.openLink) return tg.openLink(urlToShare);
    } catch {
      // fall through
    }
    window.open(urlToShare, "_blank");
  };

  const openHttpLink = (url: string) => {
    const tg = (window as any)?.Telegram?.WebApp;
    try {
      if (tg?.openLink) return tg.openLink(url);
    } catch {
      // fall through
    }
    window.open(url, "_blank");
  };

  const isTelegramWebApp = (): boolean => {
    const tg = (window as any)?.Telegram?.WebApp;
    if (!tg) return false;
    const initData = typeof tg.initData === "string" ? tg.initData.trim() : "";
    if (initData) return true;

    const qs = window.location.search || "";
    return /(?:\?|&)(tgWebAppData|tgWebAppStartParam|tgWebAppVersion)=/i.test(qs);
  };

  const handleShareClick = async (game: any, e: React.MouseEvent) => {
    e.stopPropagation();
    const toastId = toast.loading(tOr("common.loading", "Loading…"));
    try {
      const { sharelinkkey, webUrl } = await resolveCasinoShareLink(game);
      const urlToShare = isTelegramWebApp() ? buildTelegramShareLink(sharelinkkey) : webUrl;
      toast.dismiss(toastId);

      const gameName = String(game?.name ?? "").trim();
      const providerName = String(game?.provider ?? "").trim();
      const text = gameName
        ? `Check out ${gameName}${providerName ? ` (${providerName})` : ""}`
        : "Check out this game";

      setShareModalUrl(urlToShare);
      setShareModalText(text);
      setIsShareModalOpen(true);
    } catch (err) {
      console.error("generate-share-link failed", err);
      const desc = err instanceof Error && err.message && err.message !== "RS_ERR" ? err.message : null;
      toast.dismiss(toastId);
      toast.error(desc || tOr("common.somethingWentWrong", "Something went wrong"));
    }
  };

  const gotoSeeAll = (section: any) => {
    navigate("/see-all", { state: { tag: section.sectionTag, title: section.sectionTitle } });
  }

  const handlePlayClick = (game: any, section: any) => {
    const encodedLink = `/play/${btoa(`${game?.id}::${game?.tgProviderId}:${game?.provider}:${game?.subProvider}:${game?.type}:${game?.category}:${game?.tableId ? game?.tableId : ""}:${game?.isLock}:${section?.isLock}`)}`;

    if (activeWallet === "PLAY_CHIPS" && game?.isPlayChipDisabled) {
      setPendingGameLink(encodedLink);
      setShowPopup(true);
    } else if (shouldShowWagerNotice(game?.is_wager)) {
      setPendingWagerGameLink(encodedLink);
      setShowWagerNotice(true);
    } else {
      navigate(encodedLink);
    }
  };

  const getCategories = async () => {
    try {
      const response = await API.post("/webapp/get-categories", {});
      if (
        response.data?.status === "RS_OK" &&
        Array.isArray(response.data?.categories)
      ) {
        const formatted = response.data.categories.map((cat: any) => ({
          key: cat.category,
          label: cat.category,
          icon: cat.categoryIcon
        }));

        const finalCategories = [
          { key: "all", label: "All Games", icon: "src/assets/images/view-boxes-svgrepo-com.svg" },
          ...formatted
        ];
        setCategories(finalCategories);
        if (finalCategories.length > 1) {
          handleCategoryClick(finalCategories[0]);
        }
      } else {
        toast.error(t("casino.failedToFetchCategories"));
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  const fetchGamesByCategories = async (payload: any, reset: boolean = true) => {

    try {
      const response = await API.post("/webapp/get-games-by-categories", payload);

      if (response.data?.status === "RS_OK") {
        const games = response.data.games || [];
        const providers = Array.isArray(response.data.providers) ? response.data.providers : [];

        if (reset) {
          setCategoryGamesList(games);
        } else {
          setCategoryGamesList((prev) => [...prev, ...games]);
        }

        setFilteredProviderItems(providers);
        return games.length;
      } else {
        console.warn(response.data?.errorDescription);
        if (reset) setCategoryGamesList([]);
      }
    } catch (error) {
      console.error("fetchGamesByCategories error", error);
      if (reset) setCategoryGamesList([]);
    }
    return 0;
  };



  const handleApplyProviderFilters = async () => {
    setShowProviderModal(false);
    setSelectedProviders(tempSelectedProviders);

    if (tempSelectedProviders.length > 0) {
      setProviderPayload(null); // stop infinite scroll payload for filtered mode
    }

    if (tempSelectedProviders.length === 0) {
      setProviderGamesList([]);
      setCategoryGamesList([]);
      setSelectedCategory("all");
      dataSeparation(casinoData);
      return;
    }

    const selectedProvObjs = (selectedCategory === "all" ? allProviders : filteredProviderItems)?.filter(
      (prov: any) => tempSelectedProviders.includes(prov.name)
    );

    if (!selectedProvObjs || selectedProvObjs.length === 0) {
      setProviderGamesList([]);
      return;
    }

    setGamesLoading(true);

    try {
      const payload: any = {
        providers: selectedProvObjs.map((prov: any) => ({
          tgProviderId: prov.tgProviderId,
          providerName: prov.provider,
          subProviderName: prov.subProvider,
        })),
      };

      if (selectedCategory !== "all") {
        const cat = categories.find(c => c.key === selectedCategory);
        if (cat) payload.category = cat.label;
      } else if (tempSelectedProviders.length === 0) {
        payload.pageNo = 1;
        payload.pageSize = 50;
        setProviderPayload(payload);
      }

      await fetchGamesByCategories(payload);
      setProviderGamesList([]);
    } catch (err) {
      console.error("Error loading games for selected providers:", err);
    } finally {
      setGamesLoading(false);
    }
  };

  const handleCategoryClick = async (category: { key: string; label: string }) => {
    // Prevent category API call if search is active
    if (searchText.length > 4) return;
    setShowSearchInput(false);
    setSearchText(""); 
    setSearchResults([]);
    setLastSearchedText("");   

    setSelectedCategory(category.key);
    setCategoryGamesList([]);
    setAllGamesPage(1);
    setSelectedProviders([]);
    setTempSelectedProviders([]);
    setFilteredProviderItems([]);
    setGamesLoading(true);
    setHasMorePages(true);
    setFirstLoadComplete(false); 
    setProviderSearch("");

    try {
      const payload: any = {};

      if (category.key !== "all" && category.label) {
        payload.category = category.label;
      } else if (selectedProviders.length === 0) {
        payload.pageNo = 1;
        payload.pageSize = 50;
      }

      await fetchGamesByCategories(payload);

      if (category.key === "all") {
        setFirstLoadComplete(true);
      }
    } catch (error) {
      console.error("Failed to get games", error);
    } finally {
      setGamesLoading(false);
    }
  };


  const loadMoreAllGames = async () => {
    if (
      loadMoreLoading ||
      !hasMorePages ||
      selectedCategory !== "all" ||
      allGamesPage === 0 ||
      selectedProviders.length > 0 ||
      showingSearch // <- block while any search is active (API or local)
    ) {
      console.log("[LOAD MORE] blocked", {
        loadMoreLoading, hasMorePages, selectedCategory, allGamesPage,
        selectedProvidersLen: selectedProviders.length, showingSearch
      });
      return;
    }

    setLoadMoreLoading(true);
    const nextPage = allGamesPage + 1;
    try {
      let requestPayload: any = { pageNo: nextPage, pageSize: 50 };
      if (providerPayload) requestPayload = { ...providerPayload, pageNo: nextPage };

      console.log("[LOAD MORE] calling /get-games-by-categories", requestPayload);
      const newCount = await fetchGamesByCategories(requestPayload, false);
      setAllGamesPage(nextPage);
      if (newCount < 50) setHasMorePages(false);
    } catch (err) {
      console.error("[LOAD MORE] error", err);
    } finally {
      setLoadMoreLoading(false);
    }
  };



  const fetchProviders = async () => {
    try {
      const response = await API.post(`/webapp/get-providers`, {});
      if (response.data?.status === "RS_OK" && Array.isArray(response.data.providers)) {
        setAllProviders(response.data.providers);
      } else {
        toast.error(t("casino.failedToFetchProviders"));
      }
    } catch (error) {
      console.error("Error fetching providers:", error);
    }
  };

  const filteredProviders = (
    selectedCategory === "all" ? allProviders : filteredProviderItems
  )?.filter((provider: any) =>
    provider?.subProvider?.toLowerCase().includes(providerSearch.toLowerCase())
  );

  const performGameSearch = async (text: string) => {
    try {
      const response = await API.post("/webapp/game-search", { gameName: text });
      if (response.data?.status === "RS_OK") {
        const games = response.data.games || [];
        setSearchResults(games);
        setNoSearchResults(games.length === 0);
      } else {
        setSearchResults([]);
        setNoSearchResults(true);
      }
    } catch (err) {
      console.error("Game search failed", err);
      setSearchResults([]);
      setNoSearchResults(true);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const trimmedText = searchText.trim().toLowerCase();
      const isAllCategory = selectedCategory === "all";
      const noProvidersSelected = selectedProviders.length === 0;

      if (trimmedText.length === 0) {
        setSearchResults([]);
        setLastSearchedText("");
        setNoSearchResults(false);
        return;
      }

      if (isAllCategory && noProvidersSelected) {
        if (trimmedText.length >= 4 && trimmedText !== lastSearchedText) {
          performGameSearch(trimmedText);
          setLastSearchedText(trimmedText);
        } else if (trimmedText.length < 4) {
          setSearchResults([]);
          setNoSearchResults(false);
        }
      } else {
        const filtered = categoryGamesList.filter((game) =>
          game?.name?.toLowerCase().includes(trimmedText)
        );
        setSearchResults(filtered);
        setNoSearchResults(trimmedText.length > 0 && filtered.length === 0);
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [searchText, selectedCategory, selectedProviders, categoryGamesList, lastSearchedText]);


  const isAllCategory = selectedCategory === "all";
  const noProvidersSelected = selectedProviders.length === 0;
  const showingSearch =
    (isAllCategory && noProvidersSelected && searchText.trim().length >= 4) ||
    ((!isAllCategory || !noProvidersSelected) && searchText.trim().length > 0);

  const showNoGames =
    !gamesLoading && showingSearch && noSearchResults;

  const gamesToShow = showingSearch ? searchResults : categoryGamesList;

  useEffect(() => {
    if (!firstLoadComplete || selectedCategory !== "all" || selectedProviders.length > 0) return;
    if (showingSearch) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loadMoreLoading && hasMorePages) {
          loadMoreAllGames();
        }
      },
      { threshold: 1, rootMargin: "0px 0px 200px 0px" }
    );

    const currentLoader = loaderRef.current;
    if (currentLoader) observer.observe(currentLoader);

    return () => {
      if (currentLoader) observer.unobserve(currentLoader);
    };
  }, [
    firstLoadComplete,
    loadMoreLoading,
    hasMorePages,
    selectedCategory,
    selectedProviders.length,
    showingSearch,
  ]);



  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <>
      <div className="flex flex-col px-3 mt-2 w-full pb-[6rem] pt-4 casino">
        {
          loading ? (
            <div className="home-loading">
              <img src={Loader(domain)} style={{ height: '10rem' }} />
            </div>
          ) : (
            <>
              <div className="main-section">
              </div>
              <div className="sticky-controls-wrapper z-10 sticky top-[4rem] pt-4 pb-2" style={{ backgroundColor: 'var(--inputbox-color)' }}>
                {/* CATEGORY BAR */}
                <div className="category-bar flex items-center gap-2">
                  {/* Static "All Games" */}
                  {categories.length > 0 && (
                    <div
                      className={`category-tab w-[78px] h-[50px] px-1 py-1 text-center rounded-lg text-[10px] font-medium cursor-pointer border transition-all duration-300
                          ${selectedCategory === categories[0].key
                            ? `bg-border-color border-pink-300 shadow-md ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`
                            : `bg-[#101822] border border-zinc-700 text-white`
                          }`}
                      onClick={() => handleCategoryClick(categories[0])}
                      style={{
                        color: selectedCategory === categories[0].key
                          ? (buttonTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF')
                          : '#FFFFFF'
                      }}
                    >
                      <div className="flex flex-col items-center justify-center h-full w-full">
                        <img
                          loading="lazy"
                          src={boxes}
                          className={`w-4 h-4 mb-1 custom-icon-filter ${
                            selectedCategory === categories[0].key
                              ? "category-icon-unselected"
                              : "category-icon-selected"
                          }`}
                          alt={categories[0].label}
                          style={{
                            filter: selectedCategory === categories[0].key
                              ? (buttonTextColorClass === 'dark-text' ? 'brightness(0)' : 'brightness(0) invert(1)')
                              : 'brightness(0) invert(1)'
                          }}
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.onerror = null;
                            target.src = `${S3_IMG}/casino.svg`;
                          }}
                        />
                        <div className={`flex items-center justify-center text-center break-words text-[8px] w-[68px] h-[1.5rem] overflow-hidden leading-tight custom-icon-filter ${
                            selectedCategory === categories[0].key
                              ? `${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`
                              : 'text-white'
                          }`}
                          style={{
                            color: selectedCategory === categories[0].key
                              ? (buttonTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF')
                              : '#FFFFFF'
                          }}
                        >
                          {categories[0].label}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Scrollable categories */}
                  <div className="flex gap-2 ml-2 overflow-x-auto" style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
                    {categories.slice(1).map((category) => (
                      <div
                        key={category.key}
                        className={`category-tab w-[78px] h-[50px] px-1 py-1 text-center rounded-lg text-[10px] font-medium cursor-pointer border transition-all duration-300
                            ${selectedCategory === category.key
                              ? `bg-border-color border-pink-300 shadow-md ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`
                              : `bg-[#101822] border border-zinc-700 text-white`
                            }`}
                        onClick={() => handleCategoryClick(category)}
                        style={{
                          color: selectedCategory === category.key
                            ? (buttonTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF')
                            : '#FFFFFF'
                        }}
                      >
                      <div className="flex flex-col items-center justify-center h-full w-full">
                        <img
                          loading="lazy"
                          src={category.icon}
                          className={`w-4 h-4 mb-1 custom-icon-filter ${selectedCategory === category.key? "category-icon-unselected": "category-icon-selected"}`}
                          alt={category.label}
                          style={{
                            filter: selectedCategory === category.key
                              ? (buttonTextColorClass === 'dark-text' ? 'brightness(0)' : 'brightness(0) invert(1)')
                              : 'brightness(0) invert(1)'
                          }}
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.onerror = null;
                            target.src = `${S3_IMG}/casino.svg`;
                          }}
                        />
                        <div
                          className={`flex items-center justify-center text-center break-words text-[8px] w-[68px] h-[1.5rem] overflow-hidden leading-tight custom-icon-filter ${
                            selectedCategory === category.key
                              ? `${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`
                              : 'text-white'
                          } capitalize`}
                          style={{
                            color: selectedCategory === category.key
                              ? (buttonTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF')
                              : '#FFFFFF'
                          }}
                        >
                          {category.label}
                        </div>
                      </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* PROVIDER FILTER + SEARCH */}
                <div className="flex items-center justify-between mt-4">
                  <div className="flex items-center gap-2">
                    {!showSearchInput && (
                      <button
                        onClick={() => {
                          setTempSelectedProviders(selectedProviders);
                          setShowProviderModal(true);
                        }}
                        className={`flex items-center px-2 py-1 rounded bg-inputbox-color border border-border-color text-xs ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        style={{
                          color: inputBoxTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF'
                        }}
                      >
                        <img 
                          src={filter} 
                          alt="Filter" 
                          className="w-3 h-3 mr-1"
                          style={{
                            filter: inputBoxTextColorClass === 'dark-text' ? 'brightness(0)' : 'brightness(0) invert(1)'
                          }}
                        />
                        {selectedProviders.length > 0
                          ? `${t("casino.providers")} (${selectedProviders.length})`
                          : t("casino.selectProvider")}
                      </button>
                    )}

                    {selectedProviders.length > 0 && !showSearchInput && (
                      <button
                        className="flex items-center justify-center w-5 h-5 rounded bg-inputbox-color border border-border-color"
                        onClick={() => {
                          setSelectedProviders([]);
                          setTempSelectedProviders([]);
                          setProviderGamesList([]);
                          setCategoryGamesList([]);
                          setProviderPayload(null);
                          const currentCategory = categories.find(c => c.key === selectedCategory);
                          if (currentCategory) {
                            handleCategoryClick(currentCategory);
                          }
                        }}
                      >
                        <img src={Delete} alt="Delete" className="w-3 h-3" />
                      </button>
                    )}
                  </div>

                  {showSearchInput ? (
                    <div className="flex items-center w-full relative">
                     <input
                        type="text"
                        placeholder={t("casino.gameSearch")}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        className={`w-[100%] h-7 px-3 py-1 text-xs rounded bg-inputbox-color border border-border-color ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        style={{ minWidth: "auto" }}
                      />
                      <button
                        onClick={() => {
                          setShowSearchInput(false);
                          setSearchText("");
                        }}
                        className={`absolute right-3 ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                      >
                        <CloseIcon fontSize="inherit" />
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => {
                        setShowSearchInput(true);
                      }}
                      className={`ml-2 flex items-center justify-center w-7 h-7 rounded bg-inputbox-color border border-border-color ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                    >
                      <img 
                        src={search} 
                        alt="Search" 
                        className="w-3 h-3"
                        style={{
                          filter: inputBoxTextColorClass === 'dark-text' ? 'brightness(0)' : 'brightness(0) invert(1)'
                        }}
                      />
                    </button>
                  )}
                </div>
              </div>
              <div className="games-grid mt-6 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3">
                {gamesLoading ? (
                  <div className="col-span-full flex justify-center items-center min-h-[60vh]">
                    <img src={Loader(domain)} style={{ height: "5rem" }} alt="Loading..." />
                  </div>
                ) : showNoGames ? (
                  <div className="col-span-full flex justify-center items-center min-h-[40vh]">
                    <p className={`text-sm ${pageTextColorClass === 'dark-text' ? 'text-gray-600' : 'text-zinc-400'}`}>{t("casino.noGamesFound")}</p>
                  </div>
                ) : (
                  gamesToShow
                    .filter((game: any) => !game?.subProvider?.startsWith('Yuvi Games'))
                    .map((game: any, index: number) => (
                    <div
                      key={game.id + index}
                      className="game-card cursor-pointer"
                      onClick={() => handlePlayClick(game, {})}
                    >
                      <div className="game-tile relative overflow-hidden rounded-lg">
                        <img
                          loading="lazy"
                          src={game.thumbnail}
                          style={{ objectFit: "unset" }}
                          alt={game.name}
                          onError={(e) => {
                            const t = e.target as HTMLImageElement;
                            t.onerror = null;
                            t.src = "https://cdn.stwin2025.co/TG/BotYaPot/Category/stikelogo1.svg";
                          }}
                          className={`w-full h-full rounded-lg object-cover relative mb-2 ${
                            activeWallet === "PLAY_CHIPS" && game?.isPlayChipDisabled ? "greyed-out" : ""
                          }`}
                        />
                        <div className="casino-game-actions absolute top-[5px] right-[5px]">
                          <div>
                            {game?.isFavorite ? (
                              <FavoriteOutlined
                                className="gold-favourite-img"
                                titleAccess={t("casino.removeFromFavourites")}
                                onClick={(e) => { e.stopPropagation(); handleFavoriteClick(game); }}
                              />
                            ) : (
                              <FavoriteBorderOutlined
                                className="red-favourite-img"
                                style={{ fill: "white" }}
                                titleAccess={t("casino.addToFavourites")}
                                onClick={(e) => { e.stopPropagation(); handleFavoriteClick(game); }}
                              />
                            )}
                          </div>

                          <button
                            type="button"
                            className="casino-game-action-btn"
                            onClick={(e) => handleShareClick(game, e)}
                            aria-label="Share"
                            title={tOr("common.share", "Share")}
                          >
                            <IosShare className="casino-game-share-icon" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
                {/* Trigger div for infinite scroll */}
                {!showingSearch && isAllCategory && noProvidersSelected && (
                  <div ref={loaderRef} className="h-8 w-full" />
                )}

                {/* Optional loading spinner */}
                {loadMoreLoading && (
                  <div className="flex justify-center py-4">
                    <img src={Loader(domain)} alt="Loading..." className="h-6" />
                  </div>
                )}
            </>
          )
        }
      </div>
      <WagerNoticeDialog
        open={showWagerNotice}
        onCancel={() => {
          setShowWagerNotice(false);
          setPendingWagerGameLink("");
        }}
        onProceed={() => {
          if (pendingWagerGameLink) navigate(pendingWagerGameLink);
          setShowWagerNotice(false);
          setPendingWagerGameLink("");
        }}
      />
      {showPopup && (
        <Dialog
          fullScreen={false}
          open={showPopup}
          onClose={() => {
            setShowPopup(false);
          }}
          PaperProps={{
            style: {
              position: 'absolute',
              top: '5rem'
            }
          }}
        >
          <div className="dialog-bg bg-inputbox-color relative p-4">
            {/* Close Button */}
            <CloseIcon
              className={`absolute top-3 right-3 text-2xl font-semibold cursor-pointer ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
              onClick={() => setShowPopup(false)}
            />
            <div className={pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}>
              <h2 className={`text-lg font-semibold mb-2 ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("casino.realMoneyGameOnly")}</h2>
              <p className={`text-sm mb-4 ${pageTextColorClass === 'dark-text' ? 'text-gray-600' : 'text-zinc-400'}`}>
                {t("casino.playChipsNotSupported")}
              </p>

              <div className="flex justify-center">
                <button
                  type="button"
                  className={`p-2.5 w-[48%] text-sm bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem] ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                  onClick={() => {
                    setShowPopup(false);
                    setPendingGameLink("");
                  }}
                >
                  {t("common.close")}
                </button>
                {/* <button
                  type="button"
                  className="p-2.5 w-[48%] text-sm text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                  onClick={() => {
                    if (pendingGameLink) {
                      navigate(pendingGameLink);
                      setShowPopup(false);
                    }
                  }}
                >
                  Launch Game
                </button> */}
              </div>
            </div>
          </div>
        </Dialog>
      )}
      {isShareModalOpen && (
        <Dialog
          fullScreen={false}
          open={isShareModalOpen}
          onClose={() => setIsShareModalOpen(false)}
          PaperProps={{
            style: {
              position: 'absolute',
              top: '5rem',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 'min(520px, calc(100vw - 32px))',
              margin: 0,
            }
          }}
        >
          <div className="casino-share-modal">
            <div className="casino-share-modal__header">
              <h2 className={`casino-share-modal__title ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                {tOr("profile.shareOptions", "Share Options")}
              </h2>
              <button
                type="button"
                className={`casino-share-modal__x ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                onClick={() => setIsShareModalOpen(false)}
                aria-label={tOr("common.close", "Close")}
              >
                <CloseIcon fontSize="inherit" />
              </button>
            </div>

            <div className="casino-share-modal__icons">
              <button
                type="button"
                className="casino-share-modal__icon-btn"
                  onClick={async () => {
                    try {
                      await navigator.clipboard?.writeText?.(shareModalUrl);
                      toast.success(tOr("common.copied", "Copied"));
                    } catch {
                      window.prompt(tOr("common.copyLink", "Copy link"), shareModalUrl);
                    }
                  }}
                aria-label={tOr("common.copy", "Copy")}
                title={tOr("common.copy", "Copy")}
              >
                <FaCopy size={24} color="#D1D5DB" />
              </button>

              <button
                type="button"
                className="casino-share-modal__icon-btn"
                onClick={() =>
                  openHttpLink(
                    `https://wa.me/?text=${encodeURIComponent(`${shareModalText || "Check out this game"} ${shareModalUrl}`)}`
                  )
                }
                aria-label="WhatsApp"
                title="WhatsApp"
              >
                <FaWhatsapp size={24} color="#25D366" />
              </button>

              <button
                type="button"
                className="casino-share-modal__icon-btn"
                onClick={() =>
                  openTelegramShare(
                    `https://t.me/share/url?url=${encodeURIComponent(shareModalUrl)}&text=${encodeURIComponent(shareModalText || "Check out this game")}`
                  )
                }
                aria-label="Telegram"
                title="Telegram"
              >
                <FaTelegramPlane size={24} color="#0088cc" />
              </button>

              <button
                type="button"
                className="casino-share-modal__icon-btn"
                onClick={() =>
                  openHttpLink(
                    `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareModalText || "Check out this game")}&url=${encodeURIComponent(shareModalUrl)}`
                  )
                }
                aria-label="Twitter"
                title="Twitter"
              >
                <IoLogoTwitter size={24} color="#1DA1F2" />
              </button>

              <button
                type="button"
                className="casino-share-modal__icon-btn"
                onClick={() =>
                  openHttpLink(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareModalUrl)}`
                  )
                }
                aria-label="Facebook"
                title="Facebook"
              >
                <IoLogoFacebook size={24} color="#4267B2" />
              </button>
            </div>

            <button
              type="button"
              className={`casino-share-modal__close-btn bg-error-color ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
              onClick={() => setIsShareModalOpen(false)}
            >
              {tOr("common.close", "Close")}
            </button>
          </div>
        </Dialog>
      )}
      <Dialog
        fullScreen
        open={showProviderModal}
        onClose={() => setShowProviderModal(false)}
      >
        <div className="bg-[#040d1a] h-full w-full p-4 pb-4 relative">
          {/* Row 1: Back button */}
          <div className="flex items-center gap-2 mr-[21.8rem]">
            {/* Icon with fixed background */}
            <div
              onClick={() => {
                setShowProviderModal(false);
                setProviderSearch("");
              }}
              className="bg-inputbox-color p-1 rounded"
            >
              <ArrowBackIcon
                className={`aspect-square w-[18px] ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-border-color'}`}
                style={{ width: "20px", height: "20px" }}
              />
            </div>

            {/* Text stays outside the background */}
            <div className={`text-sm ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("common.back")}</div>
          </div>

          {/* Row 2: Provider Search Full Width */}
          <div className="relative w-full mt-4 mb-4">
            <input
              type="text"
              value={providerSearch}
              onChange={(e) => setProviderSearch(e.target.value)}
              placeholder={t("casino.providerSearch")}
              className={`w-full px-4 py-2 pr-10 rounded-lg bg-inputbox-color border border-border-color ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
            />
            {providerSearch ? (
              <button
                onClick={() => setProviderSearch("")}
                className={`absolute right-3 top-2.5 ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
              >
                <CloseIcon fontSize="inherit" />
              </button>
            ) : (
              <img
                src={search}
                className="absolute right-3 top-2.5 w-4 h-4"
                alt="Search"
              />
            )}
          </div>

          {/* Row 3: Selections row */}
          <div className="flex justify-between items-center mb-4">
            <span className={`text-sm ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{tempSelectedProviders.length} {t("casino.selected")}</span>
            
            <div className="flex items-center gap-3">
              {/* Delete Icon */}
              {tempSelectedProviders.length > 0 && (
                <button
                  onClick={() => setTempSelectedProviders([])}
                  className="text-white rounded-full p-1"
                >
                  <img src={Delete} alt="Delete" className="w-4 h-4" />
                </button>
              )}

              {/* List/Grid Toggle */}
              <button onClick={() => setIsListView(!isListView)}>
                <img
                  src={isListView ? grid : list}
                  alt="Toggle View"
                  className="w-4 h-4"
                />
              </button>
            </div>
          </div>

          {/* Provider Grid or List */}
          {filteredProviders?.length === 0 ? (
            <div className={`flex justify-center items-center text-sm min-h-[10rem] ${pageTextColorClass === 'dark-text' ? 'text-gray-600' : 'text-zinc-400'}`}>
              {t("casino.noProvidersFound")}
            </div>
          ) : isListView ? (
            <div className="flex flex-col gap-2 overflow-y-auto max-h-[calc(100vh-190px)] scrollbar-hide pb-[calc(env(safe-area-inset-bottom)+88px)]">
              {filteredProviders.map((prov: any, i) => {
                const isSelected = tempSelectedProviders.includes(prov.name);
                return (
                  <div
                    key={i}
                    className={`w-full px-4 py-2 pr-10 rounded-lg border border-border-color
                      ${isSelected ? `bg-border-color ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}` : `bg-inputbox-color ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}`}
                    onClick={() => {
                      setTempSelectedProviders((prev) =>
                        prev.includes(prov.name)
                          ? prev.filter((p) => p !== prov.name)
                          : [...prev, prov.name]
                      );
                    }}
                  >
                    <span className={`text-sm font-medium truncate ${isSelected ? (buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white') : (inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white')}`}>{prov.subProvider}</span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="grid grid-cols-4 gap-3 overflow-y-auto max-h-[calc(100vh-190px)] scrollbar-hide pb-[calc(env(safe-area-inset-bottom)+88px)]">
              {filteredProviders.map((prov: any, i) => {
                const isSelected = tempSelectedProviders.includes(prov.name);
                return (
                  <div
                    key={i}
                    className={`relative p-1 rounded-lg border border-border-color cursor-pointer flex flex-col items-center justify-center transition-all
                      ${isSelected ? `bg-border-color ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}` : `bg-inputbox-color ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}`}
                    onClick={() => {
                      setTempSelectedProviders((prev) =>
                        prev.includes(prov.name)
                          ? prev.filter((p) => p !== prov.name)
                          : [...prev, prov.name]
                      );
                    }}
                  >
                    <img
                      loading="lazy"
                      src={prov.thumbnail}
                      alt={prov.name}
                      className="px-1 h-12 md:h-8 mb-1"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.onerror = null;
                        target.src = `${S3_IMG}/casino.svg`;
                      }}
                    />
                  </div>
                );
              })}
            </div>
          )}
          {/* Apply Button */}
          <div className="fixed bottom-0 left-0 w-full flex justify-center px-4 pt-4 pb-[calc(env(safe-area-inset-bottom)+12px)] bg-[#040d1a] border-t border-white/10">
            <button
              onClick={handleApplyProviderFilters}
              disabled={tempSelectedProviders.length === 0}
              className={`px-10 py-3 rounded-lg font-semibold ${
                tempSelectedProviders.length === 0
                  ? "bg-gray-500 text-gray-300 cursor-not-allowed"
                  : "bg-white text-black"
              }`}
            >
              {t("common.apply").toUpperCase()}
            </button>
          </div>
        </div>
      </Dialog>
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-[6rem] right-4 bg-border-color hover:bg-bg-border-color p-3 rounded-full shadow-md z-50 transition-all"
        >
          <img src={JumpToTop} alt="Top" className="w-4 h-4" />
        </button>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    casinoData: state.userDetails?.casinoData,
    activeWallet: state.userDetails?.activeWallet,
    userDetails: state.userDetails?.userDetails,
    dynamicTextColors: state.userDetails?.dynamicTextColors,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setCasinoData: (data: any) => {
      dispatch(setCasinoData(data));
    },
    clearCasinoFilters: () => {
      // No-op function - clears casino filters if needed in the future
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CasinoIframe);